// import Vue from 'vue'
// import Vuetify from 'vuetify/lib'
// import theme from './theme'
// import 'vuetify/dist/vuetify.min.css'
// import '@mdi/font/css/materialdesignicons.css'

// Vue.use(Vuetify, {
//   iconfont: 'mdi',
//   theme
// })

import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
//import theme from './theme'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    disable: false,
    dark: false,
    themes: {
      light: {
        primary: "#081a6d",
        secondary: "#4caf50",
        tertiary: "#495057",
        accent: "#82B1FF",
        error: "#f55a4e",
        info: "#f6f8f9",
        success: "#03b689",
        warning: "#ffe686",
      },
      dark: {},
    },
  },
  icons: {
    iconfont: "mdi",
  },
});
